import {
  useQuery,
  UseQueryOptions,
  UseQueryResult,
} from '@tanstack/react-query';
import { QueryFetchFunction, QueryTransformer } from 'common/helpers/common';
import {
  ApiError,
  ApiResult,
  ExtendedApiResult,
} from 'common/repositories/common.model';

import {
  getFlightPurchasesInput,
  getFlightPurchaseInput,
  FlightPurchaseLiteModel,
  FlightPurchaseModel,
} from './model';

export function useGetFlightPurchases(
  input?: getFlightPurchasesInput,
  options?: UseQueryOptions<
    ExtendedApiResult<FlightPurchaseLiteModel[]>,
    ApiError
  >,
): UseQueryResult<ExtendedApiResult<FlightPurchaseLiteModel[]>, ApiError> {
  return QueryTransformer(
    useQuery(
      options?.queryKey ?? ['getFlightPurchases', input?.params],
      () =>
        QueryFetchFunction({
          url: 'flight-purchases',
          params: input?.params,
        }),
      options,
    ),
    FlightPurchaseLiteModel,
  );
}

export function useGetFlightPurchase(
  input?: getFlightPurchaseInput,
  options?: UseQueryOptions<ApiResult<FlightPurchaseModel>, ApiError>,
): UseQueryResult<ApiResult<FlightPurchaseModel>, ApiError> {
  return QueryTransformer(
    useQuery(
      options?.queryKey ?? ['getFlightPurchase', input?.id],
      () => QueryFetchFunction({ url: `flight-purchases/${input?.id}` }),
      options,
    ),
    FlightPurchaseModel,
  );
}

export function getFlightPurchasesKey(input?: getFlightPurchasesInput) {
  return ['getFlightPurchases', input?.params];
}

export function getFlightPurchaseKey(input?: getFlightPurchaseInput) {
  return ['getFlightPurchase', input?.id];
}
